module.exports = __webpack_public_path__ + "img/tablet.73688cb8.png";